import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import { articles } from '@/mocks/articles';

export default function ArticlesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOMeta
        title="成人精品精选文章 | 选购指南与生活灵感 - 臻品阁"
        description="臻品阁精选文章，涵盖成人精品选购指南、使用技巧、行业趋势等专业内容。助你更好地了解和选择高品质成人精品。"
        keywords="成人精品文章,成人精品指南,成人精品评测,成人精品知识,成人精品推荐"
        canonicalUrl="https://www.example.com/articles"
      />

      {/* BreadcrumbList Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.example.com/' },
              { '@type': 'ListItem', position: 2, name: '精选文章', item: 'https://www.example.com/articles' },
            ],
          }),
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 md:pt-24">
          {/* Page Header */}
          <section className="w-full py-10 md:py-14 px-6 md:px-10 bg-background-100/50">
            <div className="max-w-7xl mx-auto">
              <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line" />
                <span className="text-foreground-900 font-medium">精选文章</span>
              </nav>
              <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                精选文章
              </h1>
              <p className="mt-2 text-sm text-foreground-600">
                专业知识与生活灵感，助你更好地享受品质生活
              </p>
            </div>
          </section>

          {/* Articles Grid */}
          <section className="w-full py-10 md:py-14 px-6 md:px-10">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
                  >
                    <div className="aspect-[16/10] overflow-hidden bg-background-100">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        title={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-[10px] font-label px-2 py-0.5 rounded-full bg-accent-100 text-accent-700">
                          {article.category}
                        </span>
                        <span className="text-xs text-foreground-400">{article.readTime}</span>
                      </div>
                      <h3 className="text-sm md:text-base font-label font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                        {article.title}
                      </h3>
                      <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                        {article.summary}
                      </p>
                      <div className="mt-3 pt-3 border-t border-background-200/50 flex flex-wrap items-center gap-1.5">
                        {article.tags.map((tag) => (
                          <span
                            key={tag}
                            className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <div className="mt-3 flex items-center justify-between">
                        <span className="text-xs text-foreground-400">{article.author}</span>
                        <span className="text-xs text-foreground-400">{article.date}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}